/**
 * 微信网页授权工具类
 */
import axios from 'axios'
import { apiUrl } from '@/config/api'

export const isWechatBrowser = () => {
  return /micromessenger/i.test(navigator.userAgent)
}

const getUrlParam = (name) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  const r = window.location.search.substr(1).match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null
}

export const getWechatAuthUrl = async (redirectUri, state = '') => {
  try {
    const authorizeUrl = apiUrl('/wechat/oauth/authorize')
    console.log('[wechatAuth] request authorize', {
      api: authorizeUrl,
      redirectUri: redirectUri || window.location.href,
      state
    })
    const response = await axios.get(authorizeUrl, {
      params: {
        redirectUri: redirectUri || window.location.href,
        state: state
      },
      timeout: 10000
    })

    console.log('[wechatAuth] authorize response', response && response.data)
    if (response.data.code === 200 && response.data.data && response.data.data.authUrl) {
      return response.data.data.authUrl
    }
    const errorMsg = response.data.msg || response.data.data?.msg || '获取授权链接失败'
    throw new Error(errorMsg)
  } catch (error) {
    console.error('获取微信授权链接失败:', error)
    if (error.response) {
      const errorMsg = error.response.data?.msg || error.response.data?.message || '获取授权链接失败'
      throw new Error(errorMsg)
    }
    if (error.request) {
      throw new Error('网络请求失败，请检查网络连接')
    }
    throw error
  }
}

export const handleWechatCallback = async () => {
  const code = getUrlParam('code')
  const state = getUrlParam('state')

  if (!code) {
    return null
  }

  try {
    const response = await axios.get(apiUrl('/wechat/oauth/callback'), {
      params: {
        code: code,
        state: state
      },
      timeout: 10000
    })

    if (response.data.code === 200) {
      const { openId, userId } = response.data.data

      if (openId) {
        localStorage.setItem('wechat_openId', openId)
        if (userId) {
          localStorage.setItem('wechat_userId', userId)
        }
      }

      const url = new URL(window.location.href)
      url.searchParams.delete('code')
      url.searchParams.delete('state')
      window.history.replaceState({}, '', url.toString())

      return { openId, userId }
    }
    throw new Error(response.data.msg || '授权失败')
  } catch (error) {
    console.error('处理微信授权回调失败:', error)
    throw error
  }
}

export const getStoredOpenId = () => {
  return localStorage.getItem('wechat_openId')
}

export const clearStoredOpenId = () => {
  localStorage.removeItem('wechat_openId')
  localStorage.removeItem('wechat_userId')
}

export const initWechatAuth = async () => {
  console.log('[wechatAuth] initWechatAuth 已废弃，请使用手动授权按钮')
  return getStoredOpenId()
}
